(function () {
    'use strict';

    angular
    .module('core')
    .directive('modal', modal);

    modal.$inject = ['$sce', '$rootScope', '$timeout'];

    function modal($sce, $root, $timeout) {
        return {
            restrict: 'EA',
            transclude: true,
            templateUrl: './templates/directives/modal.html',
            scope:{
                'src':'='
            },
            link: function($scope, elem, attr) {
                $scope.$watch('modal.show', function(newVal){
                    if(newVal == true){
                        $timeout(function(){
                            $scope.modal.ready = true;
                        }, 250);
                    }
                });

                $scope.modal = $scope.src;

                $scope.close = function(){
                    if($scope.modal.persist !== true){
                        $scope.modal.show = false;
                        $root.modal = false;
                    }
                }
            }
        }
    }
})();